import * as React from "react";

const Close: React.FC = () => {
    return (
        <svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_18646_41557)">
                <path
                    d="M19 6.91L17.59 5.5 12 11.09 6.41 5.5 5 6.91l5.59 5.59L5 18.09l1.41 1.41L12 13.91l5.59 5.59L19 18.09l-5.59-5.59L19 6.91z"
                    fill="#1B1C1C"
                />
            </g>
            <defs>
                <clipPath id="clip0_18646_41557">
                    <path fill="#fff" transform="translate(0 .5)" d="M0 0H24V24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(Close);
